import { relative } from 'path';

export function normalizePath(filePath: string, rootDir?: string): string {
  if (rootDir) {
    // Strip trailing slash so boundary check uses consistent form
    const root = rootDir.endsWith('/') ? rootDir.slice(0, -1) : rootDir;
    if (filePath === root || filePath.startsWith(`${root}/`)) {
      return relative(root, filePath);
    }
  }
  return filePath;
}

export function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function isDebugEnabled(): boolean {
  return process.env.TESTDINO_DEBUG === 'true' || process.env.TESTDINO_DEBUG === '1';
}

/** Settles with `fallback` after `ms`; clears its timer so it never holds the process open. */
export async function waitAtMost<T, F>(promise: Promise<T>, ms: number, fallback: F): Promise<T | F> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  const late = new Promise<F>((resolve) => {
    timer = setTimeout(() => resolve(fallback), ms);
  });
  try {
    return await Promise.race([promise, late]);
  } finally {
    clearTimeout(timer);
  }
}

export async function withTimeout<T>(promise: Promise<T>, timeoutMs: number, operation: string): Promise<T> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  const timeoutPromise = new Promise<never>((_, reject) => {
    timer = setTimeout(() => reject(new Error(`${operation} timed out after ${timeoutMs}ms`)), timeoutMs);
  });
  try {
    return await Promise.race([promise, timeoutPromise]);
  } finally {
    clearTimeout(timer);
  }
}
